import React, { useEffect } from "react";
import {
  ActionIcon,
  Box,
  Menu,
  ScrollArea,
  Table,
  Text,
  createStyles,
} from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";

import { IconEdit, IconEye, IconTrash } from "@tabler/icons-react";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { FiExternalLink } from "react-icons/fi";
import RecordNotFound from "../../RecordNotFound";
import TableLoader from "../../TableLoader";
import ViewPayment from "./ViewPayment";
import CustomInvoicePagination from "../../Pagination/CustomInovicePagination";
import { getAllBillingPaidInvoices } from "../../../services/billinginvoice";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      // backgroundColor: "#F2F2F2",
      color: "#000 !important",
    },
    "& th:first-of-type": {
      borderTopLeftRadius: "16px !important",
      borderBottomLeftRadius: "16px !important",
    },
    "& th:last-of-type": {
      borderTopRightRadius: "16px !important",
      borderBottomRightRadius: "16px !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
    borderRadius: "15px",
  },
  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
  tableHeader: {
    borderBottom: "none !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
  },
}));

const PreviousPayments = ({ data }) => {
  const { classes, cx } = useStyles();
  const { patients } = useSelector((state) => state.patient);
  const [scrolled, setScrolled] = useState(false);
  const [payment, setPayment] = useState(false);
  const [isPreview, setIsPreview] = useState(false);

  const { allPaidInvoices, loading } = useSelector(
    (state) => state.billinginvoiceReducer
  );


  const onEdit = (row) => {
    setPayment(row);

    // setIsPreview(true)
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    getAllBillingPaidInvoices({ page: currentPage });
  }, [currentPage]);

  return (
    <>
      <ScrollArea
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        sx={{ marginTop: "30px", minHeight: "300px" }}
      >
        <Table
          // withBorder
          highlightOnHover
          enableStickyHeader
          sx={{
            fontFamily: "Inter",
            borderRadius: "15px",
            border: "1px solid #F2F2F2",
          }}
          fontSize={"sm"}
          verticalSpacing={"md"}
        >
          <thead
            className={cx(classes.header, { [classes.scrolled]: scrolled })}
          >
            <tr>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Customer Name
              </th>
              <th style={{ minWidth: "120px" }} className={classes.tableHeader}>
                Customer email
              </th>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Invocie Id
              </th>
              <th
                style={{ minWidth: "200px", fontWeight: "700" }}
                className={classes.tableHeader}
              >
                Date
              </th>
              <th style={{ minWidth: "80px" }} className={classes.tableHeader}>
                Payment Amount
              </th>
              <th style={{ minWidth: "80px" }} className={classes.tableHeader}>
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={1000}>
                  <TableLoader />
                </td>
              </tr>
            ) : allPaidInvoices &&
              allPaidInvoices?.billingpaidinvoice?.length > 0 ? (
              allPaidInvoices?.billingpaidinvoice?.map((row, index) => (
                <tr key={index}>
                  <td>{row.invoiceId.consumer.name}</td>
                  <td>{row.invoiceId.consumer.email}</td>
                  <td>{row.invoiceId.invoiceNumber}</td>
                  <td>
                    {row?.createdAt
                      ? new Date(row?.createdAt).toLocaleDateString("en-US")
                      : " date Not Available"}
                  </td>
                  <td>{row.invoiceId?.totalAmount}</td>
                  <td>
                    <Menu shadow="md" position="left" zIndex={"1000"}>
                      <Menu.Target>
                        <ActionIcon className={classes.marginTop}>
                          <BiDotsVerticalRounded
                            id="vertical-dots"
                            size={20}
                            color="#000"
                          />
                        </ActionIcon>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <Menu.Item
                          id="open-link"
                          icon={<IconEye size={14} />}
                          onClick={() => {
                            onEdit(row);
                            setIsPreview(true);
                          }}
                          // icon={<FiExternalLink size={14} />}

                          // onClick={() => {
                          //   navigate("/home/client", { state: row?.id });
                          //   handleClientSelect(row);
                          // }}
                        >
                          View
                        </Menu.Item>
                        {/* <Menu.Item icon={<IconDownload size={14} />}>Download</Menu.Item> */}

                        {/* <Menu.Item icon={<IconEdit size={14} />} onClick={open}> */}

                        {/* <Menu.Item
                        icon={<IconTrash size={14} />}
                        color="red"
                        // onClick={remove}
                      >
                        Delete
                      </Menu.Item> */}
                      </Menu.Dropdown>
                    </Menu>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={1000}>
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      height: "75vh",
                      gap: "8rem",
                    }}
                  >
                    <RecordNotFound />
                    <Text className="notFoundText">
                      You don&apos;t have any record, click on “Create Invoices”
                    </Text>
                  </Box>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </ScrollArea>
      <CustomInvoicePagination
        data={allPaidInvoices?.count}
        itemsPerPage={10}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
      />

      <ViewPayment
        row={payment}
        isPrevew={isPreview}
        setIsPreview={setIsPreview}
      />
    </>
  );
};

export default PreviousPayments;
